import type { ComputedRef } from 'vue'
import type Vue from 'vue'
import { computed, getCurrentInstance } from 'vue'
import { mapActions, mapGetters } from '../../composables'
import { CONTEXT_CONSTS } from '../../store/context/context.consts'

export interface UseContextQueryComposable {
  query: ComputedRef<string>
  setQuery: (query: string) => Promise<void>
  clearQuery: () => Promise<void>
}

export function useContextQuery(): UseContextQueryComposable {
  const {
    proxy: { $store },
  } = getCurrentInstance() as { proxy: Vue }

  const { context } = mapGetters($store, CONTEXT_CONSTS.moduleName, {
    context: CONTEXT_CONSTS.getters.context,
  })

  const { setQuery } = mapActions($store, CONTEXT_CONSTS.moduleName, {
    setQuery: CONTEXT_CONSTS.actions.setQuery,
  })

  const query = computed(() => context.value.query)

  const clearQuery = async (): Promise<void> => {
    await setQuery(undefined)
  }

  return {
    query,
    setQuery,
    clearQuery,
  }
}
